import { useEffect, useState } from 'react'

import { Print } from '@material-ui/icons'
import AddIcon from '@material-ui/icons/Add'
import GetAppIcon from '@material-ui/icons/GetApp'
import SetState from 'Components/Hooks/SetState'
import NavBarGlobal from 'Components/UI/Molecules/NavBar'
import CajaTable from 'Components/UI/Organisms/Sales/Caja'
import CreateCaja from 'Components/UI/Organisms/Sales/Caja/Create'
import ExportCaja from 'Components/UI/Organisms/Sales/Caja/Export'
import PrintCaja from 'Components/UI/Organisms/Sales/Caja/Print'
import { oemColorButton } from 'Helpers'
import { useLocation } from 'react-router-dom'
import { getUbicacion } from 'service/helpers/localstorage'
import { interfaces } from 'service/interfaces'

import TemplateGlobal from '../../Common'

const CajaTemplate = () => {
  const [dataBefore, setDataBefore] = useState()
  const [render, setRender] = useState(true)
  const { state: openExport, setOpen: setOpenExport, setClose: setCloseExport } = SetState()
  const { state: openNew, setOpen: setOpenNew, setClose: setCloseNew } = SetState()
  const { state: openPrint, setOpen: setOpenPrint, setClose: setClosePrint } = SetState()

  const location = getUbicacion() || ''
  const { pathname } = useLocation()
  const BUTTONS = [
    {
      menuIcon: <GetAppIcon fontSize="small" />,
      menuTitle: 'Exportar',
      buttonContent: <GetAppIcon />,
      onClick: setOpenExport,
      disabled: !dataBefore?.data.permissions?.ECO.export,
    },
    {
      onClick: setOpenNew,
      menuTitle: 'Nuevo',
      menuIcon: <AddIcon fontSize="small" />,
      buttonContent: 'Nuevo',
      buttonStartIcon: <AddIcon />,
      buttonStyle: dataBefore?.data.permissions.ECO.create
        ? oemColorButton(pathname, location)
        : {},
      disabled: !dataBefore?.data.permissions.ECO.create,
    },
    {
      onClick: setOpenPrint,
      menuTitle: 'Resumen',
      menuIcon: <Print fontSize="small" />,
      buttonContent: 'Resumen',
      buttonStartIcon: <Print />,
      disabled: !dataBefore?.data,
    },
  ]

  async function apiCall() {
    await interfaces.salesCaja.dataBefore().then((res) => {
      setDataBefore({
        data: res.data,
        //  permissions: res.data.permissions,
      })
    })
  }

  useEffect(() => {
    apiCall()
  }, [render])

  return (
    <div>
      <TemplateGlobal
        navbar={<NavBarGlobal title="Ventas" subTitle="Caja diaria" buttons={BUTTONS} />}
        table={<CajaTable render={render} setRender={setRender} dataBefore={dataBefore} />}
      />

      {openExport.suspense && (
        <ExportCaja open={openExport.open} onClose={setCloseExport} dataBefore={dataBefore} />
      )}

      {openNew.suspense && (
        <CreateCaja
          render={render}
          setRender={setRender}
          open={setOpenNew}
          handleClose={setCloseNew}
          dataBefore={dataBefore}
        />
      )}

      {openPrint.suspense && (
        <PrintCaja open={openPrint.open} onClose={setClosePrint} dataBefore={dataBefore} />
      )}
    </div>
  )
}

export default CajaTemplate
